import { TAB_EVENT_BET_BUILDER_ROUTE, TAB_EVENT_OPEN_BETS_ROUTE } from '../../sportsbook-constants';

const EventPageSubRoutes = {
	BET_BUILDER: TAB_EVENT_BET_BUILDER_ROUTE,
	OPEN_BETS: TAB_EVENT_OPEN_BETS_ROUTE
} as const;

export default EventPageSubRoutes;
